import React, { useState } from 'react'
import { Col, Icon, IconButton, Panel, Table } from 'rsuite'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import { sessionSetItemObj, sessionSetItemStr } from '../../utils/sessionHelpers'
import SubProjectIncomeRecordInfo from '../subProjectIncomeRecordWidgets/SubProjectIncomeRecordInfo'
import { budgetFormat } from '../../utils/formatterUtil'

export default function SubProjectBasedItemsWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { loading } = props

  const [formSchema, setFormSchema] = useState(props.schema)
  const history = useHistory()

  const fs = localStorage.getItem('fontSize')
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }

  const handleSelectRowData = (rowData) => {
    rowData.periodOfLength = formSchema.period.length || 0

    sessionSetItemObj('subProjectPeriodInfo', rowData)
    sessionSetItemStr('subProjectPeriod', rowData.periodNo)
    history.push({
      pathname: pathname.incomeAndExpense.SubProjectVoucherList,
    })
  }

  // const TagCell = ({ rowData, dataKey, ...props }) => {
  //   let bgColor = ''
  //   switch (rowData.periodStatusVal) {
  //     case '0':
  //       bgColor = '#808080'
  //       break

  //     case '1':
  //       bgColor = '#2da888'
  //       break

  //     case '2':
  //       bgColor = '#f17e23'
  //       break

  //     default:
  //       break
  //   }

  //   return (
  //     <Cell {...props}>
  //       <div
  //         className="tag"
  //         style={{
  //           backgroundColor: bgColor,
  //         }}
  //       >
  //         <span className="tag__text">{rowData[dataKey]}</span>
  //       </div>
  //     </Cell>
  //   )
  // }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered expanded>
        <SubProjectIncomeRecordInfo schema={formSchema?.projectInfo} />

        <Table
          wordWrap
          autoHeight
          loading={loading}
          data={formSchema?.period || []}
          style={{ marginTop: '20px' }}
          className="table-all-project"
          headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
        >
          <Column width={120} align="center">
            <HeaderCell style={{ ...styleHeaderCell }}>งวดที่</HeaderCell>
            <Cell>
              {(rowData) => {
                if (rowData.periodNo) {
                  return `งวดที่ ${rowData.periodNo}`
                } else {
                  return ''
                }
              }}
            </Cell>
          </Column>

          <Column width={450} minWidth={450} flexGrow>
            <HeaderCell style={{ ...styleHeaderCell }}>วันที่เริ่มต้น - วันที่สิ้นสุด</HeaderCell>
            <Cell dataKey="startAndEndDate" />
          </Column>

          <Column width={180}>
            <HeaderCell style={{ ...styleHeaderCell }}>จำนวนเงินงวด (บาท)</HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.budgetOfPeriod || 0)
              }}
            </Cell>
          </Column>

          {/* <Column width={180} align={'center'}>
            <HeaderCell style={{ ...styleHeaderCell }}>สถานะงวด</HeaderCell>
            <TagCell dataKey="periodStatus" keyPeriodStatus="periodStatusVal" />
          </Column> */}

          <Column width={150} align="center" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <IconButton
                      appearance="primary"
                      icon={<Icon icon="eye" />}
                      onClick={() => {
                        handleSelectRowData(rowData)
                      }}
                      size="xs"
                    >
                      แสดง
                    </IconButton>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
